/* eslint-disable import/prefer-default-export */
import Vue from "vue"
import siteConfig from "@/utils/siteConfig"

export function generateThumbnail(data) {
  return Vue.axios.post(`${siteConfig.siteURL}uploads/thumbnail`, data)
}
